<template>
  <div class="info-popup">
    <ELordIcon class="info-icon" icon="questionMark" @click="$emit('open')" />

    <template v-if="type === 'modal'">
      <transition name="popup-modal">
        <PopupBase v-if="open" @close="$emit('close')">
          <template #header-text v-if="title">{{ title }}</template>
          <template #body v-if="content">
            <div class="content" v-html="content"></div>
          </template>
          <template #footer>
            <a v-if="link" :href="link" target="_blank" class="link">
              {{ linkText !== '' ? linkText : $t('global.word.more_info') }}
            </a>
          </template>
        </PopupBase>
      </transition>
    </template>
    <template v-else>
      <transition name="fade" mode="out-in">
        <div class="backdrop" v-if="open" @click="$emit('close')"></div>
      </transition>

      <transition name="popup" mode="out-in">
        <div class="info-popup-content" v-if="open">
          <h1>
            <div class="close" @click="$emit('close')"></div>
            {{ title }}
          </h1>
          <div v-html="content"></div>
          <a v-if="link" :href="link" target="_blank" class="link">
            {{ linkText !== '' ? linkText : $t('global.word.more_info') }}
          </a>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import helpers from '../../mixins/helpers';
import ELordIcon from '@/components/utilities/ELordIcon';
import PopupBase from './PopupBase';

export default {
  name: 'InfoPopup',
  components: { PopupBase, ELordIcon },
  mixins: [helpers],

  props: {
    title: {
      type: String,
      default: null,
    },
    content: {
      type: String,
      default: null,
    },
    link: {
      type: String,
      default: null,
    },
    type: {
      type: String,
      default: 'popup',
      validator: (value) => ['popup', 'modal'].includes(value),
    },
    linkText: {
      type: String,
      default: '',
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.info-popup ::v-deep .popup-body {
  padding-bottom: 20px !important;
}
</style>
